import React, { useEffect, useState, useCallback } from "react";
import {
    savePostComment,savePostLike, deletePost
} from "../../services/apiPosts";
import Spinner from "../../commonComponents/Spinner";
import ListPost from "./ListPost";
import EditDiscussion from "./EditDiscussion";
import CreateDiscussion from "./CreateDiscussion";
import CreatePost from "../Posts/CreatePost";
import { getUserDetails } from "../../services/apiProfile";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import Confirmpopup from "../../commonComponents/Confirmpopup";

const MyDiscussions = (props) => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const Organiationid = userData._id;
    const [loading, setLoading] = useState(false);
    const [Feeds, setFeeds] = useState(props.Feeds || []);
    const [comment, setComment] = useState({});
    const [show, setShow] = useState(false);
    const [likedPosts, setLikedPosts] = useState({});
    const [EditStatus, setEditStatus] = useState(false);
    const [EditFeed, setEditFeed] = useState([]);
    const [open, setOpen] = useState(false);
    const [limit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const[isSucess,SetSucess]=useState(false);
    const[ResponseMessage,SetResponseMessage]=useState("");
    const[isConfirm,setConfirm]=useState(false);
    const[DeletPostid,setDeltePostId]=useState('');
    const[PostStatus,setPostStatus] = useState(false);
     
    useEffect(() => {
        if (props.Feeds && props.Feeds.length > 0) {
            setFeeds(props.Feeds);
            setLoading(false);
        } else if (!props.Feeds) {
            loadMorePosts(); // Fallback to API if no prop provided
        }
    }, [props.Feeds]);


    useEffect(() => {
       
    }, [props.Feeds]);

    const handleScroll = useCallback(() => {
        if (
            window.innerHeight + document.documentElement.scrollTop >=
            document.documentElement.offsetHeight - 100
        ) {
            if (hasMore && !loading) {
                loadMorePosts();
            }
        }
    }, [hasMore, loading]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);

    const loadMorePosts = async () => {
        if (loading || !hasMore) return; // Added !hasMore condition here

        setLoading(true);
        const currentOffset = offset; // Take snapshot to use in request
        setOffset((prev) => prev + limit); // Increment offset early

        try {
            const formData = {
                userid: props.User?.user?._id,
                offset: currentOffset,
                limit: limit,
            };

            const response = await getUserDetails(formData);
            const newPosts = response?.posts || [];

            if (newPosts.length > 0) {
                setFeeds((prev) => [...prev, ...newPosts]);
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Pagination error:", error);
        } finally {
            setLoading(false);
        }
    };


    const ClosePopup = () => {
        setOpen(false);
        setEditStatus(false);
    }

    const OpenPopup = () => {
     setPostStatus(false);   
     setOpen(true);
  }


    
    const handleLike = async (postid) => {
        const isLiked = likedPosts[postid]; // Get current liked status
        let likePayload = { postid: postid, userid: userData._id };
        let likeresponse = await savePostLike(likePayload);
        if (likeresponse.status === true) {
            // Update likedPosts state
            setLikedPosts((prevLikes) => ({
                ...prevLikes,
                [postid]: !isLiked, // Toggle the liked status
            }));
        }
    };

    const handleDelete = async (postid) => {
        setConfirm(false);
        let deletepayload = { postid: postid };
        let response = await deletePost(deletepayload);
        if (response.status === true) {
             SetSucess(true);
           SetResponseMessage("Post is Deleted!");
            setFeeds(prevFeeds => prevFeeds.filter(post => post._id !== postid));
        }

    }
    const DeletPost = async (postid) => {
        setConfirm(true);
        setDeltePostId(postid);
       
    };
    const handleEdit = (feed) => {
        if(feed.organizationId)
        setPostStatus(false); 
        else
       setPostStatus(true); 
       setEditFeed(feed);
        setEditStatus(true);
        setOpen(true);
    }

    const handleCommentChange = (postId, value) => {
        setComment((prevComments) => ({
            ...prevComments,
            [postId]: value,
        }));
    };
    const handleCommentSubmit = async (postid) => {

        let commentPayload = { comment: comment[postid], postid: postid, userid: userData._id }
        let response = await savePostComment(commentPayload);
        if (response.status === true){

             setComment((prevComments) => ({
                ...prevComments,
                [postid]: '',
            }));

        }else{
             SetSucess(true);
             SetResponseMessage(response.message);
        }
           

    };

    const handleCommentClear = (postId) => {
        setComment((prevComments) => ({
            ...prevComments,
            [postId]: '',
        }));
    }

    const showComments = async (postId) => {


    }

    return (

        <div >
              <CreateDiscussion openPop={open} closePop={ClosePopup} EditStatus={EditStatus} EditFeed={EditFeed} fetchAllFeeds={props.fetchUserDetails} Organiationid={Organiationid} source="profile"></CreateDiscussion>
            {loading ? (
                <div className="d-flex justify-content-center my-5">
                </div>
            ) : (Feeds?.map((post, index) => {
                return (
                    <ListPost post={post} index={index}
                        userData={userData} setShow={setShow}
                        DeletPost={DeletPost}
                        handleEdit={handleEdit}
                       >
                    </ListPost>
                )
            }
            ))}
 <EditDiscussion openPop={open} closePop={ClosePopup} EditStatus={EditStatus} EditFeed={EditFeed} fetchAllFeeds={props.fetchUserDetails} Organiationid={Organiationid} source="profile"></EditDiscussion>
          
            {
                PostStatus && (<CreatePost openPop={open} closePop={ClosePopup} EditStatus={EditStatus} EditFeed={EditFeed} fetchAllFeeds={props.fetchUserDetails}></CreatePost>)
            }
              {isSucess && (<ResponsePopup 
                            isSucess={isSucess} 
                            CancelPopup={() => { 
                             SetSucess(false);
                            }} 
                            message={ResponseMessage}
                          />)}
                   {isConfirm && (<Confirmpopup 
                            isConfirm={isConfirm}
                            DeletPostid={DeletPostid} 
                            handleDelete={handleDelete}
                            type="discussion"
                            CancelPopup={() => { 
                             setConfirm(false);
                            }} 
                            
                          />)}        
            {loading && (
                <div className="d-flex justify-content-center my-3">
                    <Spinner />
                </div>
            )}
        </div>
    );

};
export default MyDiscussions;
